import React from 'react';
import { Star } from 'lucide-react';
import { type TestimonialItem } from '../lib/variants';

interface TestimonialsProps {
  testimonials: TestimonialItem[];
}

const Testimonials: React.FC<TestimonialsProps> = ({ testimonials }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Co mówią firmy po wdrożeniu
          </h2>
          <p className="mt-4 text-xl text-gray-500">
            Konkretne wyniki, nie opinie.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full hover:border-cyan-200 transition">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed flex-grow">"{testimonial.content}"</p>
              <div className="mb-4 inline-flex items-center rounded-full bg-cyan-50 border border-cyan-200 px-3 py-1 text-sm font-bold text-cyan-700 w-fit">
                {testimonial.result}
              </div>
              <div className="flex items-center mt-auto pt-4 border-t border-gray-100">
                <img
                  className="h-12 w-12 rounded-full object-cover mr-4"
                  src={testimonial.image}
                  alt={testimonial.author}
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.author}</h4>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
